// IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз)
// Фасет-чипсы под строкой глобального поиска («● work.logs 18»). Раньше клик переносил чипс в ряд фильтра (CHIP-Where в CHIPS), а ряд
// фасетов сжимался до одного выбранного: бэкенд (search.globalSearch / globalRefs) считает списки уже ПОСЛЕ фильтра. Теперь — как ряд
// компаний в выборе баз (DatabasePicker, activeTenant): чипс остаётся на месте и только заливается; повторный клик снимает выбор.
// Смысл фильтра прежний: бэкенд получает тот же CHIP-Where (одно значение на binding — parse_CHIPS берёт последнее, исключения и
// множественного выбора у него нет), но в запрос он подмешивается здесь, а в ряд фильтра пользователя не попадает.
// Чистые функции (без стора и DOM) — их проверяет tests/unit/searchFacets.test.mjs; Search.vue только вызывает их.

// binding фасета → ключ списка в ответе бэкенда. Ключ строки списка совпадает с binding (row.collection, row.segment …)
export function facet_listKeys(cmd) {
    if (cmd === 'globalRefs') return { collection: 'refs_collections' }
    return { collection: 'data_collection', segment: 'data_segments', status: 'data_statuses', widget: 'data_widgets' }
}

export function facet_isBinding(cmd, binding) {
    return Object.prototype.hasOwnProperty.call(facet_listKeys(cmd), binding)
}

// словарь подписей строк списка (тот же, что в Search.load_globalSearch)
export const FACET_RELATION = { collection: 'SEGMENTS-UNION', segment: 'SEGMENTS-UNION', status: 'STATUS', widget: 'WIDGETS-TASKS' }

// IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): подпись строки (фасет, чипс строки выдачи, панель ссылок) — из словаря В МОМЕНТ РИСОВАНИЯ. fill.title (store.get_itemsSource)
// пишет row['<binding>.title'] один раз: при частичном словаре (by_ids других виджетов) или уже летящей загрузке 'all' — сырой id
// (segment-2683), а приезд полного словаря строки ответа не перечитывает (бампает только itemsSource_change_index). dicts —
// store.itemsSource; key — binding, можно путь ('_meta.collection'); словарь — FACET_RELATION[key], иначе SEGMENTS-UNION.
// Фолбэк — row['<key>.title'], затем id
export function facet_title(dicts, row, key, relation = FACET_RELATION[key] || 'SEGMENTS-UNION') {
    const id = String(key).split('.').reduce((o, k) => o?.[k], row)
    return dicts?.[relation]?.ids?.[id]?.title || row?.[key + '.title'] || id
}

export function facet_isActive(sel, binding, value) {
    return !!sel?.[binding] && sel[binding].value === value
}

// Клик по фасету. state = { sel: {binding: {value, title}}, base: {binding: rows} }; base — список фасета «без своего фильтра»
// (снимок ряда до выбора), по нему ряд и стоит на месте. toggle=false — клик «добавить в поиск» из строки выдачи: только выбрать.
// null — ничего не изменилось (повторный выбор того же без toggle), запрос не нужен.
export function facet_click(state, binding, value, title, shownRows, toggle = true) {
    const sel = { ...(state?.sel || {}) }
    const base = { ...(state?.base || {}) }
    const cur = sel[binding]
    if (cur && cur.value === value) {
        if (!toggle) return null
        delete sel[binding]
        delete base[binding]
    } else {
        if (!cur) base[binding] = (shownRows || []).slice() // смена значения внутри binding — снимок прежний
        sel[binding] = { value, title: title || String(value) }
    }
    return { sel, base }
}

// leftValue чипса CHIP-Where (обе формы: doc.WHERE[0] и doc; leftValue объектом или строкой) — как AttrChips.setChipWhere / parse_CHIPS
function _whereBinding(chip) {
    const row = chip?.doc?.WHERE?.[0] || chip?.doc
    const lv = row?.leftValue
    return lv && typeof lv === 'object' ? lv.value : lv
}

// тот же чипс, что строит AttrChips.setChipWhere (бэкенд читает его как раньше)
export function facet_chip(binding, value, title) {
    return {
        segment: 'CHIP-Where',
        title: title || `${binding}=${value}`,
        meta: { use: true, pi: 'pi-filter', cssClass: binding, facet: true },
        doc: {
            WHERE: [{
                use: true,
                leftValue: { value: binding, valueStr: binding.charAt(0).toUpperCase() + binding.slice(1) },
                condition: '=',
                rightValue: { value, valueStr: title || String(value) },
            }],
        },
    }
}

// Чипсы запроса: пользовательские + выбранные фасеты (кроме except — запрос «без своего фильтра» для снимка base). CHIP-Where
// пользователя на тот же binding выбрасывается: одно значение на binding, фасет главнее (иначе parse_CHIPS взял бы последнее молча)
export function facet_requestChips(CHIPS, sel, except) {
    const bindings = Object.keys(sel || {})
    const user = (CHIPS || []).filter(chip => !(chip?.segment === 'CHIP-Where' && bindings.includes(_whereBinding(chip))))
    const facets = bindings.filter(b => b !== except).map(b => facet_chip(b, sel[b].value, sel[b].title))
    return facets.length || user.length !== (CHIPS || []).length ? [...user, ...facets] : (CHIPS || [])
}

// Строки ряда фасета: не выбран — живой ответ; выбран — снимок base (ряд не сжимается до выбранного). Выбранный всегда в ряду,
// даже если в снимке его нет (выбран из строки выдачи)
export function facet_rows(binding, live, base, sel) {
    const s = sel?.[binding]
    const rows = s && base ? base : (live || [])
    if (!s || rows.some(row => row?.[binding] === s.value)) return rows
    const fromLive = (live || []).find(row => row?.[binding] === s.value)
    return [...rows, fromLive || { [binding]: s.value, [binding + '.title']: s.title }]
}

// После запроса: какие снимки base устарели. changed — binding, по которому только что кликнули: его снимок взят с экрана
export function facet_staleBases(sel, changed) {
    return Object.keys(sel || {}).filter(b => b !== changed)
}
